import React, { useMemo } from 'react';
import { GrowthMatrixScatterPlotDatum } from 'src/components/BeaconV2Components/GrowthMatrixScatterPlot/GrowthMatrixScatterPlot';
import ProductGrowthMatrixCard from 'src/components/BeaconV2Components/ProductGrowthMatrixCard/ProductGrowthMatrixCard';
import { getDirection } from 'src/components/BeaconV2Components/utils/chartStyles';
import { useTableData } from 'src/serverProxy/useTableData';
import { useMetricFormatter } from 'src/utils/Hooks';
import { calculatePercentChange } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';

export const ProductGrowthMatrixCardWithSales = (props: GrowthMatrixScatterPlotDatum) => {
  const formatMetric = useMetricFormatter();

  const { isLoading, data, getComparisonValuesByFieldName } = useTableData({
    buildRequest(requestBuilder) {
      requestBuilder.addConditionTermFilter('stacklineSku', 'should', [props?.stacklineSku]);
      return requestBuilder;
    },
    requestId: 'product-retailSales',
    indexName: 'sales',
    sortFieldName: 'retailSales',
    groupByFieldName: 'stacklineSku',
    fields: [
      {
        name: 'retailSales',
        displayName: 'Retail Sales'
      }
    ],
    pageNumber: 1,
    itemsPerPage: 100
  });

  const productData = useMemo(() => {
    if (data && data?.length) {
      try {
        const [productDatum] = data;
        return productDatum;
      } catch (err) {
        return null;
      }
    }
    return null;
  }, [data]);

  const [comparisonRetailSales] = useMemo(
    () => getComparisonValuesByFieldName('retailSales'),
    [getComparisonValuesByFieldName]
  );
  const retailSales = props?.retailSales || 0;

  const percentChange = calculatePercentChange(retailSales, comparisonRetailSales);

  return (
    <ProductGrowthMatrixCard
      {...props}
      mainMetric={formatMetric(retailSales, METRICTYPE.MONEY, { decimalPlaces: 1, showFullValue: false })}
      secondaryMetric={formatMetric(Math.abs(percentChange), METRICTYPE.PERCENT, {
        showFullValue: true,
        decimalPlaces: 2
      })}
      direction={getDirection(percentChange)}
      mainDisplayTitle={productData?.metadata?.product?.brandName}
      secondaryDisplayTitle={productData?.metadata?.product?.title}
      loading={isLoading}
    />
  );
};
